/**
 * DXA URL Builder Utility
 * Builds DXA (Digital Experience Accelerator) URLs with proper query parameters
 */
export function buildDxaUrl({
  baseUrl,
  hostServer,
  followId,
  pegaToken,
  channel,
  applicationId,
  action = 'openPage',
  pageId,
  pageClass,
  caseId,
  assignmentId,
  workId,
  additionalParams = {},
}) {
    const server = (process.env.REACT_APP_PEGA_BASE_URL || process.env.REACT_APP_API_BASE_URL) + '/api/v1/pega/prweb';
    const params = new URLSearchParams({
      ...(action && { action }),
      ...(pageId && { pageId }),
      ...(pageClass && { pageClass }),
      ...(caseId && { caseId }),
      ...(assignmentId && { assignmentId }),
      ...(workId && { workId }),
      ...(applicationId && { applicationId }),
      ...(channel && { channel }),
      ...(pegaToken && { pegaToken }),
      ...(followId && { followId }),
      pegaServerUrl: server,
      ...additionalParams
    });
    
    const queryString = params.toString();
    return queryString ? `${baseUrl || hostServer}?${queryString}` : baseUrl || hostServer;
}

/**
 * Validate DXA configuration
 * @param {Object} dxaConfig - DXA configuration object
 * @returns {boolean} True if configuration is valid
 */
export function validateDxaConfig(dxaConfig) {
  if (!dxaConfig) return false;
  if (dxaConfig.enabled === false) return false; // Explicitly disabled
  // Must have either baseUrl (standalone DXA app) or pegaServerUrl (traditional DXA)
  if (!dxaConfig.baseUrl && !dxaConfig.pegaServerUrl) return false;
  return true;
}

/**
 * Merge DXA parameters from WebSocket message with config defaults
 * @param {Object} webSocketParams - Parameters from WebSocket message
 * @param {Object} configDefaults - Default parameters from config
 * @returns {Object} Merged parameters
 */
export function mergeDxaParams(webSocketParams = {}, configDefaults = {}) {
  return {
    action: webSocketParams.action || configDefaults.defaultAction || 'openPage',
    pageId: webSocketParams.pageId || configDefaults.defaultPageId || 'pyHome',
    pageClass: webSocketParams.pageClass || configDefaults.defaultPageClass || 'Data-Portal',
    authFlow: webSocketParams.authFlow || configDefaults.authFlow || 'confidential',
    caseId: webSocketParams.caseId,
    assignmentId: webSocketParams.assignmentId,
    workId: webSocketParams.workId,
    ...(webSocketParams.additionalParams || {})
  };
}
